import { required, optional } from 'AppReact/schema';

export const stats = {
  assigned: required('integer'),
  callbacks: required('integer'),
  completed: required('integer'),
  reviews: required('integer'),
  withdrawn: required('integer'),
  completion_time: optional('number'),
  rating: optional('number'),
}